import { render, staticRenderFns } from "./TheAddToGroupButton.vue?vue&type=template&id=74020110&scoped=true"
import script from "./TheAddToGroupButton.vue?vue&type=script&lang=js"
export * from "./TheAddToGroupButton.vue?vue&type=script&lang=js"
import style0 from "./TheAddToGroupButton.vue?vue&type=style&index=0&id=74020110&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74020110",
  null
  
)

export default component.exports